import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Pagination from "@mui/material/Pagination";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
// import {
//   getProducts,
//   getSearchProducts,
// } from "../../feature/products/productSlice";
import TextField from "@mui/material/TextField";
import OrderData from "../../components/datatables/orders/OrderData";

const Order = () => {
  const dispatch = useDispatch();

  // const [data, setData] = useState([]);
  // const [searchApiData, setSearchApiData] = useState([]);
  // const [filterValue, setFilteValue] = useState("");
  const { response, isLoading } = useSelector((state) => state.products);

  //   useEffect(() => {
  //     window.scrollTo({ top: "0", behavior: "smooth" });
  //     dispatch(getProducts());
  //   }, [dispatch]);

  // useEffect(() => {
  //   const fetchData = ()=>{
  //     fetch(`${process.env.REACT_APP_API_KEY}/product/get_search_products`).then(response => response.json).then(json=>{
  //       setData(json)
  //       setSearchApiData(json)
  //     })
  //   }
  // }, []);

  // const handleFilter = (e) => {
  //   if (e.target.value == "") {
  //     setData(searchApiData);
  //   }
  //   else{
  //     const filterRes = searchApiData.filter(item=>item.)

  //   }
  // };

  const getPages = () => {
    if (!isLoading) return response.totalPages;
  };

  return (
    <Box component={Paper} minWidth={100} elevation={0}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        px={3}
        py={2}
      >
        <Typography variant='h3'>Products</Typography>

        <TextField
          type='search'
          size='small'
          //   onChange={(e) => dispatch(getSearchProducts(e.target.value))}
          // helperText='...Search'
          // id='searchbox'
          label='...Search'
        />
      </Box>
      <Divider />
      <Box px={3} my={3}>
        <OrderData />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          m: 5,
        }}
      >
        <Pagination
          count={getPages()}
          variant='outlined'
          showFirstButton
          showLastButton
          shape='rounded'
          //   onChange={(e, value) => {
          //       dispatch(getProducts(value - 1));
          //   }}
        />
      </Box>
    </Box>
  );
};

export default Order;
